<ng-container *ngIf="vm$ | async as vm">

  <form #frmStandpunten="ngForm" name="frmStandpunten" class="main" *ngIf="vm.punt"
    [ngClass]="vm.editPunt==vm.punt ?  'disableform' : ''">

    <div class="main__titlerow">
      <h1 class="head1">Standpunt</h1>
      <button type="button" aria-label="Annuleer wijzigen standpunt" title="Annuleer" (click)="onClose(vm.editPunt)" class="icon-button icon-disagree head2none"></button>
    </div>

    <h2 class="main__titelpuntrow head2">{{vm.punt.Titel}}</h2>

    <div class="main__algemeenstandpuntrow" *ngIf="vm.punt.Standpunt">
      <span class="algemeenstandpunt">Algemeen standpunt</span>
      <span class="green-txt-light" title="{{vm.punt.StandpuntAanvaard}} aanvaard">{{vm.punt.StandpuntAanvaard}}
        <i class="icon-agree standpunticon"></i>
      </span>
      <span class="red-txt" title="{{vm.punt.StandpuntBespreken}} bespreken">{{vm.punt.StandpuntBespreken}}
        <i class="icon-disagree standpunticon"></i>
      </span>
      <span title="{{vm.punt.StandpuntOnbepaald}} onbepaald">{{vm.punt.StandpuntOnbepaald}}
        <i class="icon-udecided standpunticon"></i>
      </span>
    </div>

    <div class="main_standpuntrow" *ngIf="vm.punt.Standpunt">

      <div style="display:flex;flex:1 1 auto;" *ngIf="vm.punt && (vm.punt != vm.editPunt); else inputstandpunt">

        <div role="radiogroup" aria-labelledby="radiotitle" class="main__standpuntrow__icons head4" *ngIf="vm.punt.Standpunt">
          <span id="radiotitle" style="display: none;">Bepaal standpunt</span>
          <button type="button" role="radio" [attr.aria-checked]="vm.punt.Standpunt.Status===0" (click)="setStatusPunt(vm,0)" aria-label="Instellen standpunt onbepaald" title="Instellen standpunt onbepaald" class="icon-button" [ngClass]="vm.punt.Standpunt.Status===0 ? 'icon-undecided-filled' : 'icon-udecided-circle'"></button>
          <button type="button" role="radio" [attr.aria-checked]="vm.punt.Standpunt.Status===2" (click)="setStatusPunt(vm,2)" aria-label="Instellen standpunt aanvaard" title="Instellen standpunt aanvaard" class="icon-button" [ngClass]="vm.punt.Standpunt.Status===2 ? 'icon-agree-filled' : 'icon-agree-circle'"></button>
          <button type="button" role="radio" [attr.aria-checked]="vm.punt.Standpunt.Status===1" (click)="setStatusPunt(vm,1)" aria-label="Instellen standpunt bespreken" title="Instellen standpunt bespreken" class="icon-button" [ngClass]="vm.punt.Standpunt.Status===1 ? 'icon-disagree-filled' : 'icon-disagree-circle'"></button>
        </div>

        <div class="main__standpuntrow__commentaar">
          {{vm.punt.Standpunt.Commentaar}}
        </div>

        <div class="main_standpuntrow__editicon">
          <button (click)="editPuntOpmerkingSubj.next(vm.punt)" title="Wijzig opmerking"
            class="icon-button main_standpuntrow__editicon icon-pencil " [disabled]="vm.punt.Standpunt.Status!==1"
            [ngClass]="{'icon-pencil--enabled c2-clickable':vm.punt.Standpunt.Status===1}">
          </button>
        </div>

      </div>

      <ng-template #inputstandpunt>
        <div style="display:flex;flex:1 1 auto;margin-top:1em;" class="enableform">

          <textarea style="flex:1 1 auto" [(ngModel)]="vm.editStandpuntStatus.Commentaar" name="commentaar" rows="4">
          </textarea>
          <button (click)="modifyOpmerkingSubj.next(vm)" aria-label="Opmerking bewaren" title="Opmerking bewaren" class="icon-button icon-agree-circle"></button>
          <button (click)="closeOpmerkingSubj.next(true)" aria-label="Opmerking niet bewaren" title="Opmerking niet bewaren" class="icon-button icon-disagree-circle"></button>

        </div>
      </ng-template>

    </div>


    <div class="subpunten" *ngIf="vm.subpunten">
      <div class="subpunten__row" *ngFor="let subpunt of vm.subpunten">

        <div role="radiogroup" class="subpunten__row__icons head4none" *ngIf="!vm.punt.SubPuntenZijnOpties">
          <button role="radio" [attr.aria-checked]="subpunt.Standpunt.Status===0" (click)="setStatusSubpunt(vm,subpunt,0)" title="Instellen standpunt onbepaald" class="icon-button"
            [ngClass]="subpunt.Standpunt.Status===0 ? 'icon-undecided-filled' : 'icon-udecided-circle'">
          </button>
          <button role="radio" [attr.aria-checked]="subpunt.Standpunt.Status===2" (click)="setStatusSubpunt(vm,subpunt,2)" title="Instellen standpunt aanvaard" class="icon-button"
            [ngClass]="subpunt.Standpunt.Status===2 ? 'icon-agree-filled' : 'icon-agree-circle'">
          </button>
          <button role="radio" [attr.aria-checked]="subpunt.Standpunt.Status===1" (click)="setStatusSubpunt(vm,subpunt,1)" title="Instellen standpunt bespreken" class="icon-button"
            [ngClass]="subpunt.Standpunt.Status===1 ? 'icon-disagree-filled' : 'icon-disagree-circle'">
          </button>
        </div>

        <div class="subpunten__row__titel">
          <h3 class="head4none">{{subpunt.Titel}}</h3>

          <div class="" *ngIf="!vm.punt.SubPuntenZijnOpties">
            <span *ngIf="vm.editPunt!=subpunt; else inputstandpunt">{{subpunt.Standpunt.Commentaar}}</span>
            <ng-template #inputstandpunt>
              <div style="display:flex;flex:1 1 auto;" class="enableform">
                <textarea style="flex:1 1 auto;" rows="8" [(ngModel)]="vm.editStandpuntStatus.Commentaar"
                  name="commentaar"></textarea>
                <button (click)="modifySubpuntOpmerkingSubj.next(vm)" title="Standpunt aanvaard" class="icon-button icon-agree-circle"></button>
                <button (click)="closeOpmerkingSubj.next(true)" title="Standpunt niet aanvaard" class="icon-button icon-disagree-circle"></button>
              </div>
            </ng-template>
          </div>

          <div class="subpuntenrow__algemeenstandpunt">
            <span class="algemeenstandpunt">Algemeen standpunt</span>
            <span class="green-txt-light" title="{{subpunt.StandpuntAanvaard}} aanvaard" >{{subpunt.StandpuntAanvaard}}
              <i class="icon-agree standpunticon"></i>
            </span>
            <span class="red-txt" title="{{subpunt.StandpuntBespreken}} bespreken">{{subpunt.StandpuntBespreken}}
              <i class="icon-disagree standpunticon"></i>
            </span>
            <span title="{{subpunt.StandpuntOnbepaald}} onbepaald">{{subpunt.StandpuntOnbepaald}}
              <i class="icon-udecided standpunticon"></i>
            </span>
          </div>
        </div>

        <div class="subpunten__row__edit">
          <button *ngIf="!vm.punt.SubPuntenZijnOpties" class="icon-button icon-pencil" title="Wijzig opmerking"
            [disabled]="subpunt.Standpunt.Status!==1"
            [ngClass]="{'icon-pencil--enabled c2-clickable':subpunt.Standpunt.Status===1}"
            (click)="editPuntOpmerkingSubj.next(subpunt)"></button>

                        
        </div>

      </div>
    </div>
  </form>
</ng-container>